import { Component, EventEmitter, OnInit, Output, ViewChild, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { process, State, filterBy, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { IPerformanceBodPackages } from 'src/app/api/performance-bod-package';
import { IPerformanceBodSaltWaterDisposal } from 'src/app/api/performance-bod-salt-water-disposal';
import { PerformanceBodStoreService } from 'src/app/services/performance-bod-store.service';
import { PerformanceBodSaltWaterDisposalService } from './standard-facilities-salt-water-disposal.service';
import { IPerformanceBodSummary } from 'src/app/api/performance-bod-summary';
import { StandardFacilitiesSummaryService } from 'src/app/modules/performance-bod/standard-facilities-summary/standard-facilities-summary.service';
import { IPerformanceBodPads } from 'src/app/api/performance-bod-pads';
import { UtilService } from 'src/app/services/util.service';
import { PermissionsProvider } from 'src/app/services/permissions.provider';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DragAndDropService } from 'src/app/_shared/drag-and-drop.service';
import { PerformanceConfigurationService } from 'src/app/services/performance-configuration-service';
import { Globals } from 'src/app/_shared/Globals';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PerformanceAFEService } from '../performance-afe/performance-afe.service';

const DRAGGABLE_SELECTOR = '.standard-facilities-swd-draggable';

@Component({
    selector: 'app-standard-facilities-salt-water-disposal',
    templateUrl: './standard-facilities-salt-water-disposal.component.html',
    styleUrls: ['./standard-facilities-salt-water-disposal.component.css'],
    standalone: false
})
export class StandardFacilitiesSaltWaterDisposalComponent implements OnInit {
  public filter: CompositeFilterDescriptor;
  public filterable: boolean = true;
  public warningMessage: string =
    'Please provide a Well Pad Name on the Package Information Section (Performance BOD Summary Tab) before adding a new record';
  public rowIndex: any = -1;
  public countWellPadName: number = 0;
  public openDialog: boolean = false;
  public messageDuplicate = true;
  public view: Observable<GridDataResult>;
  public performanceStdFacilitiesList: IPerformanceBodSummary[];
  public performanceBodPackagesList: IPerformanceBodPackages[];
  public performanceBodPadsList: IPerformanceBodPads[];
  public performanceBodPadsFilter: IPerformanceBodPads[] = [];
  public performanceBodSaltWaterDisposalList: IPerformanceBodSaltWaterDisposal[] = [];
  public performanceBodSaltWaterDisposalConcat: IPerformanceBodSaltWaterDisposal[] = [];
  public canEditPerformanceBod: boolean = false;
  public performanceBodId: string;
  public formGroup: UntypedFormGroup;
  public gridState: State = {
    sort: [],
    skip: 0,
  };
  public performanceBodSaltWaterDisposalService: PerformanceBodSaltWaterDisposalService;
  @Output() public performanceBodUpdate = new EventEmitter<string>();
  @Output() public saveBodCompleted = new EventEmitter<boolean>();
  @ViewChild('performanceBodSWD')
  private saltWaterDisposalGrid: any;
  private dragAndDropService: DragAndDropService;
  public perfAfeSvc: PerformanceAFEService;
  public afeList : any[];
  public projectTypeList = [{ id: 1, name: 'New' }, { id: 2, name: 'Expansion' }, { id: 3, name: 'Addition' }];
  constructor(
    public globals: Globals,
    private performanceBodStoreService: PerformanceBodStoreService,    
    private spinner: NgxSpinnerService,
    private formBuilder: UntypedFormBuilder,
    private standardFacilitiesSummaryService: StandardFacilitiesSummaryService,
    private utilService: UtilService,
    private permissionsProvider: PermissionsProvider,
    private authenticationService: AuthenticationService,
    private performanceConfigurationService: PerformanceConfigurationService,
    @Inject(DragAndDropService) dragAndDropServiceFactory: any,
    @Inject(PerformanceBodSaltWaterDisposalService) performanceBodSaltWaterDisposalServiceFactory: any,
    private route: ActivatedRoute,
    @Inject(PerformanceAFEService) performanceAFEServiceFactory: any,
  ) {
    this.dragAndDropService = dragAndDropServiceFactory();
    this.performanceBodSaltWaterDisposalService = performanceBodSaltWaterDisposalServiceFactory();
    this.perfAfeSvc = performanceAFEServiceFactory();

  }

  public ngOnInit() {   
    this.performanceBodStoreService.performanceBodSignatured$.subscribe((isSignature) => {
      this.canEditPerformanceBod = isSignature? false: this.permissionsProvider.canEditPerformanceBod;
    });

    this.performanceBodStoreService.performanceBodPackagesData$.subscribe(data => {
      this.performanceBodPackagesList = data;
    });

    this.performanceBodStoreService.performanceBodPadsData$.subscribe(data => {
      this.performanceBodPadsList = data.filter(row => row.wellPadName !== '');
    });

    this.performanceBodStoreService.performanceBodId$.subscribe(id => {
      this.performanceBodId = id;
      this.performanceBodSaltWaterDisposalService.performanceBodId = id;
      this.performanceBodSaltWaterDisposalService.read();
    });

    this.performanceBodStoreService.performanceBodSummary$.subscribe(data => {
      this.performanceStdFacilitiesList = data;  
    });

    this.performanceBodStoreService.performanceBodSaltWaterDisposal$.subscribe(data => {
      this.performanceBodSaltWaterDisposalList = data;
    });

    this.view = this.performanceBodSaltWaterDisposalService.pipe(
      map(data => {
        this.dragAndDropService.dataSourceRefreshed(data);
        return process(filterBy(data, this.filter), this.gridState);
      })
    );    

    this.dragAndDropService.initialize(this.performanceBodSaltWaterDisposalService.data, DRAGGABLE_SELECTOR, () => {
      this.performanceBodSaltWaterDisposalService.markAsSetOrder(this.authenticationService.getCurrentUser());
    });
  }

  public ngAfterViewInit(): void {
    // To Do
  }

  public ngOnDestroy(): void {
    this.dragAndDropService.refreshDragAndDrop();
  }

  public createFormGroup(dataItem: any): UntypedFormGroup {
    return this.formBuilder.group({
      id: new UntypedFormControl(dataItem.id),
      isDeleted: new UntypedFormControl(dataItem.isDeleted),
      sortOrder: new UntypedFormControl(dataItem.sortOrder),
      name: new UntypedFormControl(dataItem.name, [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
      performanceBodPadsId: new UntypedFormControl(dataItem.performanceBodPadsId, Validators.required),
      projectType: new UntypedFormControl(dataItem.projectType, [Validators.required]),
      performanceBodPackagesId: new UntypedFormControl(dataItem.performanceBodPackagesId),
      capacity: new UntypedFormControl(dataItem.capacity, [Validators.min(0), Validators.max(1000000)]),
      injectionPressurePsig: new UntypedFormControl(dataItem.injectionPressurePsig, [
        Validators.min(0),
        Validators.max(1000000),
      ]),
      inLetPressurePsig: new UntypedFormControl(dataItem.inLetPressurePsig, [Validators.min(0), Validators.max(1000000)]),
      peakWaterVolumeP70: new UntypedFormControl(dataItem.peakWaterVolumeP70, [Validators.min(0), Validators.max(1000000)]),
      peakWaterVolumeP90: new UntypedFormControl(dataItem.peakWaterVolumeP90, [Validators.min(0), Validators.max(1000000)]),
      comments: new UntypedFormControl(dataItem.comments, [Validators.minLength(1), Validators.maxLength(500)]),
      createdBy: [dataItem.createdBy],
      createdDate: [dataItem.createdDate],
      updatedBy: [dataItem.updatedBy],
      updatedDate: [dataItem.updatedDate],
      chargeCode: new UntypedFormControl(dataItem.chargeCode, [
        Validators.maxLength(13),
        Validators.pattern('^[a-zA-Z0-9]{0,13}$'),
      ]),
      cndHoEstimate: new UntypedFormControl(dataItem.cndHoEstimate, [Validators.min(0), Validators.max(999999999999)]),
      rfsdDate: new UntypedFormControl(dataItem.rfsdDate),
      afeNumber: new UntypedFormControl(dataItem.afeNumber, [
        Validators.maxLength(13),
        Validators.pattern('^[a-zA-Z0-9]{0,13}$'),
      ]),
      afeAmount: new UntypedFormControl(dataItem.afeAmount, [
        Validators.maxLength(8),
        Validators.pattern('^[a-zA-Z0-9]{0,8}$'),
      ]), 
    });
  }

  public cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
    if (!isEdited && this.canEditPerformanceBod) {
      if (dataItem.rfsdDate !== undefined && columnIndex === 7) {
        if (dataItem.rfsdDate !== null) {
          const y = new Date(dataItem.rfsdDate.toString()).getFullYear();
          const m = new Date(dataItem.rfsdDate.toString()).getMonth();
          const d = new Date(dataItem.rfsdDate.toString()).getDate();
          dataItem.rfsdDate = new Date(y, m, d);
        }
      }

      sender.editCell(rowIndex, columnIndex, this.createFormGroup(dataItem));
      this.dragAndDropService.onEditingMode();
    }
  }

  public cellCloseHandler(args: any) {
    const { formGroup, dataItem, column } = args;

    let columnField = '';

    if (column.field === 'performanceBodPackagesName') {
      columnField = 'performanceBodPackagesId';
    }
    if (column.field === 'performanceBodPadsName') {
      columnField = 'performanceBodPadsId';
    } else {
      columnField = column.field;
    }
    const checkColumn = formGroup.controls[columnField];

    if (!checkColumn.valid) {
      args.preventDefault();
    } else if (checkColumn.dirty) {
      if (columnField === 'performanceBodPackagesId') {
        dataItem.performanceBodPackagesName = this.getPerformanceBodPackages(formGroup.controls[columnField].value);
      }
      if (columnField === 'performanceBodPadsId') {
        dataItem.performanceBodPadsName = this.getPerformanceBodPads(formGroup.controls[columnField].value);
      }
    }

    if (!formGroup.valid) {
      // prevent closing the edited cell if there are invalid values.
      args.preventDefault();
    } else if (formGroup.dirty) {
      if (formGroup.valid && args.sender.data.total > 0) {
        for (let i = 0; i <= args.sender.data.total - 1; i++) {
          if (
            args.sender.data.data[i].name === formGroup.value.name.trim() &&
            args.sender.data.data[i].performanceBodPackagesId === formGroup.value.performanceBodPackagesId &&
            args.sender.data.data[i].id !== formGroup.value.id
          ) {
            this.messageDuplicate = false;
            args.preventDefault();
            return;
          } else {
            this.messageDuplicate = true;
          }
        }
      }

      if (this.messageDuplicate === true) {
        dataItem.updatedDate = new Date();
        dataItem.updatedBy = this.authenticationService.getCurrentUser();

        // Date is not working in Object.assign(), so need to be do it manually
        formGroup.value.updatedBy = dataItem.updatedBy;
        formGroup.value.updatedDate = dataItem.updatedDate;

        this.performanceBodSaltWaterDisposalService.assignValues(dataItem, formGroup.value);
        this.performanceBodSaltWaterDisposalService.updateItem(dataItem);
      }
    }
    // calls this to add the attribute of current row
    this.dragAndDropService.onEditingClose();
    this.dragAndDropService.refreshDragAndDrop();
  }

  public addHandler({ sender, rowIndex }) {
    const item: IPerformanceBodSaltWaterDisposal = {
      id: Guid.create().toString(),
      name: '',
      performanceBodPadsId: '',
      performanceBodPackagesId: '',
      performanceBodPackagesName: '',
      performanceBodPadsName: '',
      comments: null,
      capacity: 0,
      injectionPressurePsig: 0,
      inLetPressurePsig: 0,
      peakWaterVolumeP70: 0,
      peakWaterVolumeP90: 0,
      isDeleted: false,
      createdBy: this.authenticationService.getCurrentUser(),
      createdDate: new Date(),
      updatedBy: null,
      updatedDate: null,
      sortOrder: 0,
      chargeCode: null,
      cndHoEstimate: 0,
      rfsdDate: null,
      afeNumber: null,
      afeAmount: 0,
      projectType:''
    };

    if (this.performanceBodPadsList.length >= 0) {
      for (const pad of this.performanceBodPadsList) {
        if (pad.wellPadName === '') {
          this.countWellPadName = this.countWellPadName + 1;
        }
      }
      if (this.countWellPadName === this.performanceBodPadsList.length) {
        this.openDialog = true;
        this.cancelHandler({ sender, rowIndex });
        this.countWellPadName = 0;
        return;
      } else {
        item.createdBy = this.authenticationService.getCurrentUser();
        item.createdDate = new Date();

        sender.addRow(this.createFormGroup(item));
        this.dragAndDropService.onEditingMode();
      }
    }
  }

  public cancelHandler({ sender, rowIndex }) {
    this.messageDuplicate = true;
    sender.closeRow(rowIndex);
    this.dragAndDropService.onEditingClose();
    this.dragAndDropService.refreshDragAndDrop();
  }

  public saveHandler({ sender, formGroup, rowIndex }) {
    if (formGroup.valid && sender.data.total > 0) {
      for (let i = 0; i <= sender.data.total - 1; i++) {
        if (
          sender.data.data[i].name === formGroup.value.name.trim() &&
          sender.data.data[i].performanceBodPackagesId === formGroup.value.performanceBodPackagesId &&
          sender.data.data[i].id !== formGroup.value.id
        ) {
          this.messageDuplicate = false;
          return;
        } else {
          this.messageDuplicate = true;
        }
      }
    }

    if (this.messageDuplicate) {
      if (formGroup.valid) {
        if (this.performanceBodPadsList.length >= 0) {
          for (const pad of this.performanceBodPadsList) {
            if (pad.wellPadName === '') {
              this.countWellPadName = this.countWellPadName + 1;
            }
          }
          if (this.countWellPadName === this.performanceBodPadsList.length) {
            this.openDialog = true;
            this.countWellPadName = 0;
            return;
          } else {
            this.performanceBodSaltWaterDisposalService.createItem(formGroup.value);
            sender.closeRow(rowIndex);
            this.dragAndDropService.onEditingClose();
            this.dragAndDropService.dataSourceRefreshed(this.performanceBodSaltWaterDisposalService.data);
            this.dragAndDropService.refreshDragAndDrop();
            this.performanceBodSaltWaterDisposalService.markAsSetOrder(this.permissionsProvider.cai);
          }
        }
      } else {
        this.utilService.markFormGroupAsTouched(formGroup);
      }
    }
  }

  public removeHandler({ sender, dataItem }) {
    dataItem.isDeleted = true;
    this.performanceBodSaltWaterDisposalService.removeItem(dataItem);

    sender.cancelCell();
  }

  public saveFromBOD(countNotification: number): number {
    if (this.saltWaterDisposalGrid.isEditing()) {
      this.saltWaterDisposalGrid.closeCell();
    }

    const swdId = this.performanceConfigurationService.appConfigs.find(
      config => config.code === this.globals.APP_CONFIG_FACILITY_TYPE_SWD_ID);

    if (this.performanceBodSaltWaterDisposalService.hasChanges()) {
      countNotification = countNotification + 1;
      this.performanceBodSaltWaterDisposalService.createdItems.forEach(element => {
        const item: IPerformanceBodSummary = {
          id: Guid.create().toString(),
          trainsCompressorPumpsId: 'f7c75fb0-2e86-40d6-9248-7f451309c17f',
          performanceBodPadsId: element.performanceBodPadsId,
          performanceBodPadsName: null,
          comments: null,
          numberOfTrains: null,
          numberOfCompressors: null,
          numberOfPumps: null,
          numberOf3608: null,
          numberOf3516: null,
          numberOf3606: null,  
          productionRatesOil: null,
          productionRatesWater: null,
          productionRatesGas: null,
          facilityCapacityOil: null,
          facilityCapacityWater: null,
          facilityCapacityGas: null,
          spGravityOil: null,
          spGravityWater: null,
          spGravityGas: null,
          numberAfe: null,
          sourCorrosive: false,
          sourCorrosiveText: 'No',
          latitude: null,
          longitude: null,
          facilityTypeId: swdId.attributeId,
          facilityTypeName: null,
          pisAssociatedQuestion: null,
          stdDesignQuestion: null,
          gasRequiredQuestion: null,
          hdpeQuestion: null,
          fiberOpticQuestion: null,
          blmProjectQuestion: null,
          facilityLocationQuestion: null,        
          sftDesignYear: null,
          readyForServiceDate: null,
          bodLockdownDate: null,
          isDeleted: false,
          createdBy: this.authenticationService.getCurrentUser(),
          createdDate: new Date(),
          updatedBy: null,
          updatedDate: null,
          performanceBodCtbSwdCs: element.id,
          sortOrder: 0,
          //afeNumber : element.afeNumber
        };
        this.standardFacilitiesSummaryService.createdItems.push(item);
      });

      this.performanceBodSaltWaterDisposalService.deletedItems.forEach(element => {
        const findIt = this.standardFacilitiesSummaryService.originalData.find(
          x => x.performanceBodCtbSwdCs === element.id
        );

        if (findIt) {
          findIt.performanceBodPadsId = element.performanceBodPadsId;
          findIt.isDeleted = true;
          findIt.updatedBy = this.authenticationService.getCurrentUser();
          findIt.updatedDate = new Date();
          //findIt.afeId = element.afeId;
          this.standardFacilitiesSummaryService.deletedItems.push(findIt);

          // Remove from updated in case it need does
          const deletedIndex = this.standardFacilitiesSummaryService.updatedItems.findIndex(x => x.id === findIt.id);
          if (deletedIndex > -1) {
            this.standardFacilitiesSummaryService.updatedItems.splice(deletedIndex, 1);
          }
        }
      });

      this.performanceBodSaltWaterDisposalService.updatedItems.forEach(element => {
        const findIt = this.standardFacilitiesSummaryService.originalData.find(
          x => x.performanceBodCtbSwdCs === element.id
        );

        // First review if is not un the delete list yet.
        const willBeDeleted = this.standardFacilitiesSummaryService.deletedItems.find(
          x => x.performanceBodPadsId === findIt.performanceBodCtbSwdCs
        );
        if (!willBeDeleted) {
          if (findIt) {
            const toBeUpdated = this.standardFacilitiesSummaryService.updatedItems.find(
              x => x.performanceBodCtbSwdCs === findIt.performanceBodCtbSwdCs
            );
            if (toBeUpdated) {
              toBeUpdated.performanceBodPadsId = element.performanceBodPadsId;
              toBeUpdated.updatedBy = this.authenticationService.getCurrentUser();
              toBeUpdated.updatedDate = new Date();
              //toBeUpdated.afeId = element.afeId;
            } else {
              const item: IPerformanceBodSummary = {
                id: findIt.id,
                trainsCompressorPumpsId: findIt.trainsCompressorPumpsId,
                performanceBodPadsId: element.performanceBodPadsId,
                performanceBodPadsName: findIt.performanceBodPadsName,
                comments: findIt.comments,
                numberOfPumps: findIt.numberOfPumps,
                numberOfTrains: null,
                numberOfCompressors: null,
                numberOf3608: null,
                numberOf3516: null,
                numberOf3606: null,  
                productionRatesOil: null,
                productionRatesWater: null,
                productionRatesGas: null,
                facilityCapacityOil: null,
                facilityCapacityWater: null,
                facilityCapacityGas: null,
                spGravityOil: null,
                spGravityWater: null,
                spGravityGas: null,
                numberAfe: null,
                sourCorrosive: false,
                sourCorrosiveText: 'No',
                latitude: null,
                longitude: null,
                facilityTypeId: swdId.attributeId,
                facilityTypeName: null,
                pisAssociatedQuestion: null,
                stdDesignQuestion: null,
                gasRequiredQuestion: null,
                hdpeQuestion: null,
                fiberOpticQuestion: null,
                blmProjectQuestion: null,
                facilityLocationQuestion: null,                   
                sftDesignYear: findIt.sftDesignYear,
                readyForServiceDate: findIt.readyForServiceDate,
                bodLockdownDate: findIt.bodLockdownDate,
                isDeleted: false,
                createdBy: findIt.createdBy,
                createdDate: findIt.createdDate,
                updatedBy: this.authenticationService.getCurrentUser(),
                updatedDate: new Date(),
                performanceBodCtbSwdCs: findIt.performanceBodCtbSwdCs,
                sortOrder: 0,
                //afeId : findIt.afeId
              };

              this.standardFacilitiesSummaryService.updatedItems.push(item);
            }
          }
        }
      });

      // calls this to add the attribute of current row
      this.dragAndDropService.refreshDragAndDrop();
      this.performanceBodSaltWaterDisposalService.saveChanges();
      this.performanceBodUpdate.next(this.authenticationService.getCurrentUser());
      const subscription = this.performanceBodSaltWaterDisposalService.subscribe(() => {
        this.saveBodCompleted.next(true);
      });

      subscription.unsubscribe();

      if (
        this.standardFacilitiesSummaryService.createdItems.length > 0 ||
        this.standardFacilitiesSummaryService.deletedItems.length > 0 ||
        this.standardFacilitiesSummaryService.updatedItems.length > 0
      ) {
        this.standardFacilitiesSummaryService.markAsSetOrder(this.authenticationService.getCurrentUser());
        this.standardFacilitiesSummaryService.saveChanges();
        this.standardFacilitiesSummaryService.cancelChanges();
      }

      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
        this.performanceBodSaltWaterDisposalService.cancelChanges();
        this.standardFacilitiesSummaryService.cancelChanges();
      }, 3000);
    }
    return countNotification;
  }

  public cancelChanges(grid: any): void {
    this.messageDuplicate = true;
    grid.cancelCell();
    this.dragAndDropService.refreshDragAndDrop();
    this.performanceBodSaltWaterDisposalService.cancelChanges();
  }

  public onStateChange(state: State) {
    this.gridState = state;
    this.performanceBodSaltWaterDisposalService.read();

    // const viewSubscription = this.view.subscribe(data => {
    //   this.dragAndDropService.dataSourceRefreshed(data.data);
    // });

    // viewSubscription.unsubscribe();
    // this.dragAndDropService.runZoneOnStable();
  }

  public getPerformanceBodPackages(id: string): any {
    if (this.performanceBodPackagesList === null || this.performanceBodPackagesList === undefined) {
      return '';
    }
    return this.performanceBodPackagesList.find(x => x.id === id);
  }

  public changePackage(value, dataItem, formGroup: UntypedFormGroup) {
    let performanceBodPad: IPerformanceBodPads[];
    let performanceBodPackagesId: string;
    performanceBodPad = this.performanceBodPadsList.filter(s => s.id === value);
    performanceBodPad.forEach(element => {
      performanceBodPackagesId = element.performanceBodPackagesId;
    });

    dataItem.performanceBodPackagesId = performanceBodPackagesId;
    formGroup.patchValue({
      performanceBodPackagesId,
    });
  }

  public getPerformanceBodPads(id: string): any {
    if (this.performanceBodPadsList === null || this.performanceBodPadsList === undefined) {
      return '';
    } else {
      return this.performanceBodPadsList.find(x => x.id === id);
    }
  }

  public ValidationMessage(formGroup: any, args: any) {
    if (formGroup.valid && args.sender.data.total > 0) {
      for (let i = 0; i < args.sender.data.total - 1; i++) {
        if (
          args.sender.data.data[i].name === formGroup.value.name.trim() &&
          args.sender.data.data[i].performanceBodPackagesId === formGroup.value.performanceBodPackagesId
        ) {
          this.messageDuplicate = false;
          args.preventDefault();
          return;
        } else {
          this.messageDuplicate = true;
        }
      }
    }
  }

  public closeKendoPopUp() {
    this.openDialog = false;
  }

  public handlerFilter(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    if (filter.filters) {
      if (filter.filters.length > 0) {
        this.dragAndDropService.onEditingMode();
      } else {
        this.dragAndDropService.onEditingClose();
        this.dragAndDropService.refreshDragAndDrop();
      }
    }
  }

  public rowCallback(context: RowClassArgs) {
    return {
      dragging: context.dataItem.dragging,
    };
  }

  public rowLoaded(): void {
    // to check until grid have been loeaded.
    this.dragAndDropService.checkIsOnEditMode();
    this.dragAndDropService.checkDraggableElementLoaded();
  }

  public getAfe(id: string): any {
    if (this.afeList === null || this.afeList === undefined) {
      return '';
    }
    return this.afeList.find(x => x.id === id);
  }

  public changeAfe(value, dataItem, formGroup: UntypedFormGroup) {
    let afeArray: any[];
    let afeId: string;
    afeArray = this.afeList.filter(s => s.id === value);
    afeArray.forEach(element => {
      afeId = element.id;
    });

    dataItem.afeId = afeId;
    formGroup.patchValue({
      afeId,
    });
  }

  public getAfeList() {
    this.perfAfeSvc.performanceBodId = this.performanceBodId;
    this.perfAfeSvc.retrieve().subscribe((data) => {
      if (data.length > 0) {
        this.afeList = data;
      }
    });
  }
  public getProjectType(projectType?: number): any {
    if (projectType === null || projectType === undefined) {
      return '';
    } else {
      if (this.projectTypeList) {
        return this.projectTypeList.find(f => f.id === projectType).name;
      }
    }
    return '';
  }

  public onChangeProjectType(value, dataItem: IPerformanceBodSummary, formGroup: UntypedFormGroup) {
    dataItem.projectType = value;
  }

}
